/**
 * Parametr `?groupBy=` ekranu „Moje czekające" → wymiar grupowania z białej listy tego ekranu
 * (`PENDING_DECISION_GROUP_BY`). Jedno miejsce prawdy dla zakładki (czyta parametr z adresu) i dla
 * kafelków strony „Akceptacje" (przenoszą wybrane grupowanie między widokami tej samej zakładki).
 *
 * Biała lista to NIE pełny `DECISION_GROUP_BY`: wymiar ważny na innym ekranie (np. `status`) nie
 * jest tu wymiarem — serwer odrzuciłby go jako błędne zapytanie, a zakładka ignoruje go jak brak
 * grupowania.
 */

import { PENDING_DECISION_GROUP_BY } from '@saas/shared';

/** Wymiar grupowania dozwolony na ekranie „Moje czekające" (węższy niż `DecisionGroupBy`). */
export type PendingDecisionGroupBy = (typeof PENDING_DECISION_GROUP_BY)[number];

/** Wymiar z białej listy „Moje czekające" albo `null` (brak parametru, pusty lub nieznany). */
export function parsePendingGroupBy(value: string | null): PendingDecisionGroupBy | null {
  return PENDING_DECISION_GROUP_BY.find((dimension) => dimension === value) ?? null;
}
